/**
 * config入口點
 * 集中將設定檔export出去
 * 引入只需 @/assets/config
 */
import { systemMenu } from './menu';
import { API } from './api';

export { systemMenu, API };